/**
 * The four finishes at the current size (PosterBaseOptions) : the customer's poster shown in each —
 * the editor's own moulding pictures (assets/images/frame-<finish>-<size>.png, transparent inside)
 * laid over it when the poster stands upright, the handoffs' flat colours otherwise —, the
 * catalogue's name, line and price. A frame the current size is not made in (59 × 84) is shown,
 * not offered.
 */
fx.ns("shared.components", class PosterFinishOptions extends shared.components.PosterBaseOptions {

    get kind() { return "finish"; }

    get title()
    {
        return this.mobile ? fx.text("Choisissez votre finition") : fx.text("Comment voulez-vous l'afficher ?");
    }

    get subtitle()
    {
        // none in the sheet, as for the sizes
        if (this.mobile)
            return "";

        return fx.text("Aperçu avec votre photo, au format $.", this.dimensionsLabel(this.dimensions(this.creation.format || {})));
    }

    // swatch and flat border : the handoffs' colours (the mobile one has its own wood)
    get FINISHES()
    {
        return [
            { code : "standard", swatch : "#FFFFFF" },
            { code : "wood", swatch : this.mobile ? "#C9A27A" : "#B98A5B" },
            { code : "black", swatch : "#1C1C1C" },
            { code : "white", swatch : "#FAFAF8" },
        ];
    }

    // the poster's height in a card, and its flat border : the handoffs'
    get FRAME_HEIGHT() { return this.mobile ? 132 : 236; }
    get BORDER() { return this.mobile ? 9 : 14; }

    // the moulding's width in its picture, a share of the picture's width (measured on the PNGs)
    get MOULDING_WIDTH() { return { small : 0.065, medium : 0.055, big : 0.047 }; }

    // the editor's moulding for a finish at the current size, when there is one
    _moulding(code)
    {
        if (code == "standard" || this.creation.shape_option == "landscape" || !this.creation.format)
            return null;

        let asset = fx.assets["frame" + code.capitalize() + String(this.creation.format.size || "").capitalize()];
        if (!asset)
            return null;

        return typeof asset == "string" ? asset : (asset.content || asset.url || null);
    }

    cards()
    {
        let Base = shared.components.PosterBaseOptions;
        let creation = this.creation;
        let current = creation.option ? creation.option.editor_code : "standard";
        let size = this.dimensions(creation.format || {});
        let height = this.FRAME_HEIGHT;
        let width = Math.round(height * size.width / size.height);

        return this.FINISHES.map((finish) => {
            let option = creation.optionForType(finish.code, false, false);
            let any = option || creation.optionForType(finish.code, true, false);
            if (!any)
                return null;

            let selected = finish.code == current;
            let moulding = this._moulding(finish.code);
            let frame;

            if (moulding)
            {
                // the whole frame the size of the poster's box, the poster in its opening
                let inset = Math.round(width * (this.MOULDING_WIDTH[creation.format.size] || 0.055));
                frame = '<span class="poFrame poFrame--' + finish.code + ' poFrame--moulding" style="width:' + width + 'px;height:' + height + 'px">' +
                            '<img class="poArt" alt="" style="top:' + inset + 'px;left:' + inset + 'px;width:' + (width - inset * 2) + 'px;height:' + (height - inset * 2) + 'px">' +
                            '<img class="poMoulding" alt="" src="' + Base.escape(moulding) + '">' +
                        '</span>';
            }
            else
            {
                let border = finish.code == "standard" ? 0 : this.BORDER;
                frame = '<span class="poFrame poFrame--' + finish.code + '" style="width:' + width + 'px;height:' + height + 'px;border-width:' + border + 'px;border-color:' + finish.swatch + '">' +
                            '<img class="poArt" alt="">' +
                        '</span>';
            }

            return { id : finish.code, html :
                '<button type="button" class="poCard" data-action="choose" data-id="' + finish.code + '" aria-pressed="' + selected + '"' + (option ? '' : ' disabled') + '>' +
                    '<span class="poStage">' + frame + '</span>' +
                    '<span class="poInfo">' +
                        '<span class="poHead"><span class="poSwatch" style="background:' + finish.swatch + '"></span><span class="poName">' + Base.escape(any.option.shortname) + '</span></span>' +
                        '<span class="poTag">' + (option ? Base.escape(any.option.text) : fx.text("Pas disponible dans cette taille")) + '</span>' +
                        (option ? '<span class="poPrice">' + this.price(option) + '</span>' : '') +
                    '</span>' +
                    Base.check() +
                '</button>' };
        }).filter(Boolean);
    }

    apply(code)
    {
        let option = this.creation.optionForType(code, false, false);
        if (option)
            this.creation.updateOption(option.option_id);
    }
});
